import {
  createStonePriceRule,
  deleteStonePriceRule,
  listStonePriceRules,
  updateStonePriceRule,
  type CreateStonePriceRuleRequest,
  type StonePriceRule,
  type UpdateStonePriceRuleRequest,
} from '@nucleus-commerce/api-client/admin';

/** Markup bands on supplier stone cost; a bounded organization list served whole. */
export const stonePricingApi = {
  list: (): Promise<StonePriceRule[]> => listStonePriceRules().then((r) => r.items),
  create: (body: CreateStonePriceRuleRequest): Promise<StonePriceRule> =>
    createStonePriceRule(body),
  update: (id: string, body: UpdateStonePriceRuleRequest): Promise<StonePriceRule> =>
    updateStonePriceRule({ id }, body),
  remove: (id: string): Promise<void> => deleteStonePriceRule({ id }),
};
